import { makeAutoObservable } from 'mobx';
import { isBefore } from 'date-fns';
import {
    PersonalAssetHistoryDto,
    OperationTypeEnum,
    PersonalAssetHistoryWithCumulativeDto,
} from '../../../../defs/api';
import { PersonalAssetHistoryMetaDataMobxDto } from './personal-asset-history-meta-data-mobx-dto';

export class PersonalAssetHistoryMobxDto implements PersonalAssetHistoryWithCumulativeDto {
    metaData?: PersonalAssetHistoryMetaDataMobxDto;

    operationType: OperationTypeEnum | null;

    id: string;

    value: number;

    cumulativeValue: number;

    personalAssetId: string;

    date: Date;

    public note: string = '';

    constructor() {
        makeAutoObservable(this);
    }

    static create(dto: PersonalAssetHistoryDto): PersonalAssetHistoryMobxDto {
        const mobxDto = new PersonalAssetHistoryMobxDto();
        return Object.assign(mobxDto, dto, {
            metaData: dto.metaData ? PersonalAssetHistoryMetaDataMobxDto.create(dto.metaData) : undefined,
        });
    }

    static createFromArray(dtos: PersonalAssetHistoryDto[]): {
        items: PersonalAssetHistoryMobxDto[];
        latestDate?: Date;
    } {
        const createdDtos: PersonalAssetHistoryMobxDto[] = [];
        let latestDate = dtos[0]?.date;
        dtos.forEach((dto) => {
            createdDtos.push(PersonalAssetHistoryMobxDto.create(dto));
            if (isBefore(latestDate, dto.date)) {
                latestDate = dto.date;
            }
        });

        return {
            items: createdDtos,
            latestDate,
        };
    }
}
